export default __webpack_public_path__ + "static/media/car-card.db25af8b.png";